import { css, styled } from "@mui/material";

import { cssPropertiesToString } from "@utils";

export const GridyList = styled("ul")(
  ({ theme }) => css`
    columns: 1;
    column-gap: 4rem;
    padding-left: 1rem;

    & > li {
      break-inside: avoid;
    }

    ${theme.breakpoints.up("tablet")} {
      columns: 2;
    }

    ${theme.breakpoints.up("desktopXl")} {
      columns: 3;
    }
  `,
);

export const ServiceTitle = styled("p")(
  ({ theme }) => css`
    display: inline-flex;

    ${cssPropertiesToString(theme.typography.paragraph_xsmall_regular)}

    ${theme.breakpoints.up("desktop")} {
      ${cssPropertiesToString(theme.typography.paragraph_small_regular)}
    }
  `,
);
